export default `제1조 (목적)

이 약관은 주식회사 프리플랍(이하 “회사”)이 단독으로 주최하거나 제휴를 통해 운영하는 프리롤 홀덤 대회(이하 “프리롤 대회”)에 참가하고자 하는 회원을 대상으로, 참가 신청 절차, 참가 조건, 권리 및 의무, 기타 필요한 사항을 규정함을 목적으로 합니다.

제2조 (정의)

이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. “프리롤 대회”란 회사가 프리미엄 회원을 대상으로, 참가비 없이 운영하는 텍사스 홀덤 기반의 이벤트성 대회를 말합니다. 각 대회는 선착순 또는 랜덤 추첨 방식으로 운영되며, 대회별로 운영 방식과 참가 인원이 다를 수 있습니다.
2. “ 프리미엄 회원”이란 프리플랍 앱에 가입하고 회사가 제공하는 서비스를 이용하는 자로서, 유료 구독 상태인 자를 의미합니다.
3. “참가자”란 본 약관에 따라 프리롤 대회에 참가 신청을 완료하고, 실제로 대회에 참여한 회원을 말합니다.
4. “참가 신청”이란 회원이 프리롤 대회에 참여하기 위해 회사가 지정한 방식으로 신청 절차를 진행하는 행위를 말합니다.
5. “참가권”이란 대회 참가 자격을 의미하며, 선착순 또는 추첨 방식으로 회사가 부여합니다. 참가권은 양도 또는 매매할 수 없습니다.
6. “운영진”이란 회사가 프리롤 대회의 운영, 진행, 심판 등을 위해 지정한 스태프를 말합니다.

제3조 (신청 및 승인)

1. 프리롤 대회 참가 신청은 회사가 지정한 공식 경로(예: 앱 내 신청 시스템, 푸시 알림, 공지사항 등)를 통해서만 가능합니다.
2. 참가자는 회사가 요구하는 정보를 정확하고 성실하게 기재해야 하며, 허위 정보나 타인의 정보를 도용한 경우 참가 승인이 제한되거나 취소될 수 있습니다.
3. 회사는 각 대회별로 정해진 운영 방식(선착순 또는 랜덤 추첨 방식 등)에 따라 참가자를 선정하며, 대회별로 신청 조건 및 인원 제한이 다를 수 있습니다.
4. 회사는 다음 각 호에 해당하는 경우 참가 신청을 거부하거나, 이미 승인된 참가를 취소할 수 있습니다.
    1. 과거 대회에서 부정행위, 무단 불참, 질서 문란 등의 이력이 있는 경우
    2. 허위 정보를 기재하거나 타인의 정보를 도용한 경우
    3. 해당 대회의 신청 자격 조건(예: 유료 회원 상태, 등급 요건 등)을 충족하지 못한 경우
    4. 대회 운영에 지장을 초래할 우려가 있다고 회사가 판단한 경우
5. 참가 승인을 받은 회원은 대회 당일 안내된 시간 및 장소(또는 온라인 환경 등)에 따라 등록 및 참가 절차를 완료해야 하며, 무단 불참 또는 지각 시 향후 대회 참가에 제한이 있을 수 있습니다.

제4조 (참가자의 의무)

1. 참가자는 다음 각 호의 사항을 성실히 준수해야 합니다.
    1.1. 본 약관, 회사의 운영정책, 프리롤 대회 운영 규칙 및 공지사항
    1.2. 운영진의 지시 및 안내 사항
    1.3. 대회 신청 및 참가 과정에서 허위 정보 입력 또는 타인의 명의 사용 금지
    1.4. 대회 진행 중 타인에게 피해를 주거나 질서를 해치는 언행 금지
    1.5. 참가권의 타인 양도, 매매, 공유 행위 금지
2. 참가자는 다음 각 호에 해당하는 행위를 해서는 안 됩니다.
    2.1. 사전 허가 없이 대회 장면을 촬영, 녹화, 중계하거나 무단 배포하는 행위
    2.2. 부정행위로 간주될 수 있는 일체의 행위 (예: 칩 고의 투척, 신호 주고받기 등)
    2.3. 도박성 내기, 불법 행위 유도, 타 참가자 또는 운영진에 대한 폭언·비방 등
3. 참가자는 안내된 시간 내에 대회 등록 및 본인 확인 절차를 완료해야 하며, 이를 이행하지 않을 경우 참가가 제한되거나 실격 처리될 수 있습니다.
4. 회사는 참가자가 본 조의 의무를 위반한 경우, 사전 통지 없이 실격 처리, 향후 프리롤 대회 참가 제한, 회원 자격 정지 등의 조치를 취할 수 있습니다.

제5조 (대회 변경 및 취소)

1. 회사는 다음 각 호에 해당하는 경우, 프리롤 대회의 전부 또는 일부를 변경, 연기, 중단 또는 취소할 수 있습니다.
    1.1. 천재지변, 재난, 감염병 확산 등 불가항력적 사유
    1.2. 시스템 장애, 기술적 오류, 보안 문제 등 운영상 중대한 장애 발생 시
    1.3. 참가자 미달, 제휴처의 협력 중단, 기타 불가피한 내부 사정
2. 제1항에 따라 대회 변경 또는 취소가 발생한 경우, 회사는 앱 내 공지사항, 푸시 알림, 문자, 이메일 등의 방법으로 가능한 한 신속히 참가자에게 통지합니다. 참가자의 귀책사유(예: 지각, 무단 불참, 본인 확인 실패 등)로 인해 대회에 참가하지 못한 경우, 참가권의 양도, 환불, 이월 또는 대체 참가 기회는 제공되지 않습니다.
3. 회사 귀책 사유로 인해 대회가 전면 취소된 경우, 회사는 참가자에게 추후 프리롤 대회 우선 참여권, 포인트 또는 이에 준하는 방식으로 별도 보상을 제공할 수 있습니다.
4. 회사는 대회의 일부 구성(예: 포맷, 대회 방식, 상금 구성, 참가 인원, 진행 방식 등)을 사전 공지 후 변경할 수 있으며, 참가자는 변경 사항에 이의를 제기할 수 없습니다.
5. 참가자가 정당한 사유 없이 반복적으로 대회에 무단 불참할 경우, 회사는 해당 참가자의 향후 프리롤 또는 공식 대회 참가를 제한할 수 있습니다.

제6조 (촬영 및 초상권 활용 동의)

1. 참가자는 프리롤 대회 진행 중 회사 또는 제휴사, 운영진 등에 의해 사진, 영상, 음성 등이 촬영 또는 녹음될 수 있음을 인지하고, 이에 동의합니다.
2. 회사는 촬영된 자료를 다음 각 호의 목적 범위 내에서 사용할 수 있습니다.
    2.1. 대회 결과 공지 및 이벤트 기록 보관
    2.2. 프리플랍 앱, 홈페이지, SNS, 유튜브 등을 통한 홍보 및 마케팅 콘텐츠 제작
    2.3. 서비스 내 콘텐츠(예: 하이라이트 영상, 교육용 자료 등) 제작
3. 위 자료는 회사의 필요에 따라 편집·가공될 수 있으며, 참가자는 이에 대해 초상권, 저작권, 또는 기타 권리 주장이나 금전적 보상을 요구할 수 없습니다.
4. 참가자가 초상권 활용에 대해 민감한 사유가 있는 경우, 사전 또는 대회 직후 서면(전자 포함)으로 제한 요청을 할 수 있으며, 회사는 합리적 범위 내에서 이를 검토하고 반영할 수 있습니다.
5. 참가자는 회사의 사전 동의 없이 대회 현장을 상업적 목적으로 촬영, 중계, 녹화, 실시간 방송하는 행위를 해서는 안 됩니다.

제7조 (책임 제한)

1. 회사는 다음 각 호의 사유로 인해 프리롤 대회가 정상적으로 진행되지 못하거나 참가자에게 손해가 발생한 경우, 그 책임을 지지 않습니다.
    1.1. 천재지변, 감염병 확산, 정전, 통신 장애 등 불가항력적 사유
    1.2. 시스템 장애, 운영상 긴급 점검 또는 기술적 문제 등 예기치 못한 사유
    1.3. 참가자의 귀책사유(예: 지각, 장비 오류, 앱 미설치, 통신 불안정 등)
    1.4. 참가자의 규정 미숙지 또는 운영정책 위반으로 인한 불이익
2. 회사는 참가자의 개인 사정(건강 이상, 일정 착오, 사고 등)으로 인한 참가 불능, 실격, 불이익에 대해 책임을 지지 않으며, 참가권 환불 또는 대체 참가 기회를 제공하지 않습니다.
3. 회사는 프리롤 대회에서 제공되는 리워드(예: 포인트, 이벤트 경품 등)에 대해, 사전 고지된 범위 내에서만 책임을 지며, 리워드의 품질, 배송, 사용 등에 대한 별도의 법적 책임을 부담하지 않습니다.
4. 프리롤 대회는 이벤트 성격의 무료 참여 대회로, 참가자는 회사가 별도의 상해보험, 손해보험에 가입하지 않음을 인지하고 필요한 경우 스스로 보호 조치를 취해야 합니다.

제8조 (분쟁 해결 및 관할)

1. 본 약관 및 프리롤 대회 참가와 관련하여 회사와 참가자 간에 발생한 분쟁에 대해서는 대한민국 법률을 준거법으로 합니다.
2. 참가자는 대회 진행, 신청, 보상 등과 관련한 민원 또는 이의가 있을 경우, 앱 내 고객센터 또는 이메일 등 회사가 지정한 방식으로 이의제기를 할 수 있으며, 회사는 이에 대해 성실히 검토하고 처리합니다.
3. 회사와 참가자 간 분쟁이 원만하게 해결되지 않아 소송이 제기되는 경우, 회사의 본점 소재지를 관할하는 지방법원을 제1심 전속 관할 법원으로 합니다.
4. 참가자가 대한민국 외 지역에 거주하거나 외국 국적자일 경우에도, 본 조의 규정은 동일하게 적용됩니다.
`